@if (savingsAccountService.testMode() || savingsAccountService.applicant().personalNumber) {
  <spb-form/>
} @else {
  <section class="text-container">
    <mat-card>
      <mat-card-content>
        @if (notAdult) {
          <h1>Hej!</h1>

          <p>
            Vi ser att du är intresserad av vår tjänst som endast är tillgänglig
            för personer över 18 år.
          </p>
          <p>
            Vi vill gärna erbjuda dig andra möjligheter och föreslår vårt Ung i
            Syd-paket. Där kan du hitta information om produkter och tjänster
            som är speciellt utformade för unga. Vi hoppas att du hittar det du
            söker!
          </p>
          <p>

            Om du har några frågor eller behöver ytterligare information är du
            välkommen att kontakta oss.
          </p>

          <div class="button">
            <a
              spbAccessibleLink
              href="https://www.sparbankensyd.se/sv/privat/din-banklosning/vara-erbjudanden/vara-paketerbjudanden/ung-i-syd"
              target="_blank"
              matButton="filled">
              Ung i Syd
            </a>
          </div>
        } @else {
          <h1>
            @if (routeService.onHorseRoute()) {
              Snart är du igång med ditt sparande!
            } @else {
              Vad roligt att du vill öppna ett konto!
            }
          </h1>
          <p>För att gå vidare behöver du ha ett BankID.</p>
          <p>Saknar du ett BankID är du välkommen att besöka ett av våra kontor,
            <a
              spbAccessibleLink
              href="https://www.sparbankensyd.se/sv/privat/om-oss/kontakt"
              target="_blank">klicka här för kontaktinformation</a>.
          </p>

          <spb-bankid
            [style.margin-top.rem]="2"
            [domain]="domain"
            customButton="Öppna BankID"
            mode="login"
            [bankIdUrl]="authServiceUrl"
            (accessToken)="setToken($event)"
            (click)="this.savingsAccountService.sessionTimeout.set(false)"
          />
        }
        @if (savingsAccountService.sessionTimeout()) {
          <div class="session-timeout">
            Ansökan avbröts. Vänligen logga in igen för att påbörja en ny
            ansökan.
          </div>
        }
      </mat-card-content>
    </mat-card>
  </section>

}


